import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { SimService } from './sim.service';
import { normalizeMsisdn } from './sim.utils';

@Component({
  selector: 'mprd-sim',
  templateUrl: './sim.component.html',
})
export class SimComponent {
  msisdn: string;
  simType: 'sim' | 'esim';

  constructor(
    private route: ActivatedRoute,
    private simService: SimService,
  ) {
    this.msisdn = normalizeMsisdn(this.route.snapshot.params.msisdn);
    this.simType = this.route.snapshot.data.simType;
  }

  onSwitchToEsim(): void {
    this.simService.navigateToEshareEsimPage(this.msisdn);
  }
}
